import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { capacitorPreferencesStorage } from "./capacitor-preferences.storage";

const STORAGE_KEY = "tanstackQueryCache";

export const queryPersister = createAsyncStoragePersister({
  storage: capacitorPreferencesStorage,
  key: STORAGE_KEY,
  throttleTime: 1_000,
});
